// ** Redux Imports
import { createSlice } from '@reduxjs/toolkit'

// ** UseJWT import to get config
import useJwt from '@src/auth/jwt/useJwt'

const config = useJwt.jwtConfig

const initialUser = () => {
  const item = window.localStorage.getItem('userData')
  //** Parse stored json or if none return initialValue
  return item ? JSON.parse(item) : {}
}

const initialUserAbilities = () => {
  const item = window.localStorage.getItem('userAbilities')
  //** Parse stored json or if none return initialValue
  return item ? JSON.parse(item) : {}
}


export const authSlice = createSlice({
  name: 'authentication',
  initialState: {
    userData: initialUser(),
    userAbilities: initialUserAbilities()
  },
  reducers: {
    handleLogin: (state, action) => {
      state.userData = action.payload.user_data
      state.userAbilities = action.payload.user_abilities
      state[config.storageTokenKeyName] = action.payload.access_token
      localStorage.setItem('userData', JSON.stringify(action.payload.user_data))
      localStorage.setItem('userAbilities', JSON.stringify(action.payload.user_abilities))
      localStorage.setItem(config.storageTokenKeyName, JSON.stringify(action.payload.access_token))
    },
    handleLogout: state => {
      state.userData = {}
      state[config.storageTokenKeyName] = null
      // ** Remove user, accessToken & refreshToken from localStorage
      localStorage.removeItem('userData')
      localStorage.removeItem('userAbilities')
      localStorage.removeItem(config.storageTokenKeyName)
    },
    handleUpdateUserData: (state, action) => {
      state.userData = action.payload
      localStorage.setItem('userData', JSON.stringify(action.payload))
    }
  }
})

export const { handleLogin, handleLogout, handleUpdateUserData } = authSlice.actions

export default authSlice.reducer
